import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=758d6c21&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=758d6c21&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758d6c21",
  null
  
)

export default component.exports